import { Badge } from '@/components/ui/badge'
import { Typography } from '@/components/ui/typography'
import { cn } from '@/lib/utils'

export default function WebsiteDesignEditorHeader({
  eyebrow = 'Website builder',
  title,
  description,
  icon: Icon,
  badges = [],
  actions = null,
  compact = false,
  className = '',
}) {
  return (
    <section
      data-slot="admin-page-header"
      className={cn('shrink-0 px-1 py-1.5 sm:px-2', className)}
    >
      <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
        <div className={cn('min-w-0 space-y-1', compact && 'lg:space-y-0')}>
          <div className="flex flex-wrap items-center gap-2">
            <Typography variant="eyebrow">{eyebrow}</Typography>

            {badges.map((badge) => {
              const BadgeIcon = badge.icon

              return (
                <Badge key={badge.label} variant={badge.variant ?? 'secondary'}>
                  {BadgeIcon ? (
                    <BadgeIcon className={cn('fill-current', badge.iconClassName)} />
                  ) : null}
                  {badge.label}
                </Badge>
              )
            })}
          </div>

          {!compact ? (
            <div className="flex min-w-0 items-center gap-2">
              {Icon ? <Icon className="size-5 shrink-0 text-muted-foreground" /> : null}
              <Typography variant="h4" className="truncate">
                {title}
              </Typography>
            </div>
          ) : null}

          {!compact && description ? (
            <Typography variant="supporting" className="hidden md:block">
              {description}
            </Typography>
          ) : null}
        </div>

        {actions ? (
          <div className="flex shrink-0 flex-wrap items-center gap-2 lg:justify-end">{actions}</div>
        ) : null}
      </div>
    </section>
  )
}
